module.exports = __webpack_public_path__ + "img/40_38_050_760.04643780.jpg";